export default () => next => action => {
    if (!action.async) {
        return next(action);
    }

    if (action.startType) {
        next({
            payload: action.startPayload,
            type: action.startType,
        });
    }

    return action.promise()
        .then((result) => {
            if (action.successType) {
                next({
                    payload: result,
                    type: action.successType,
                });
            }

            return result;
        })
        .catch((error) => {
            if (action.errorType) {
                next({
                    payload: error,
                    type: action.errorType,
                });
            }

            return Promise.reject(error);
        });
};



// WEBPACK FOOTER //
// ./src/middleware/middleware.js